import { useTranslation } from "react-i18next";
import ReactSelect from "react-select";
import cn from "classnames";
import { getStoredFilters } from "@utils/filters";
import { PATIENT_KEY } from "@utils/constants";

const DxSelector = ({
  onChange,
  customStyles,
  className,
}: {
  onChange: Function;
  customStyles: any;
  className: any;
}) => {
  const { t } = useTranslation();
  const storedValue = getStoredFilters(PATIENT_KEY);

  const dxOptions = [
    { value: "all", label: t("all") },
    { value: "Inicial", label: t("initial") },
    { value: "Secundario", label: t("secondary") },
  ];

  return (
    <div className={cn(className)}>
      <ReactSelect
        className={cn("select", " h-[36px] w-[130px] 2xl:w-[170px]  py-0")}
        defaultValue={
          storedValue.dx
            ? { value: storedValue.dx, label: storedValue.dx }
            : null
        }
        options={dxOptions}
        styles={customStyles}
        placeholder={t("dxSubtype")}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#ED5939",
            primary25: "#F4F4F4",
          },
        })}
        onChange={({ value }: any) => onChange(value)}
      />
    </div>
  );
};

export default DxSelector;
